import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=b298e126&scoped=true"
import script from "./Manager.vue?vue&type=script&lang=js"
export * from "./Manager.vue?vue&type=script&lang=js"
import style0 from "./Manager.vue?vue&type=style&index=0&id=b298e126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b298e126",
  null
  
)

export default component.exports